import React from 'react';
import styled from 'styled-components';
import { CardApplyThemeType } from '@sunbit-dev/card-apply/src/styles/theme';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SProgress = styled.ul<{}>(
  ({ theme }) => `
  font-size: ${theme.font.size.smallMedium};
  font-weight: ${theme.font.weight.light};
  list-style: none;
  margin:0;
  padding:0;
  display: flex;
  justify-content: flex-start;
`
);

const stepBackgroundColor = (theme: CardApplyThemeType, isCurrent: boolean, isCompleted: boolean) => {
  if (isCurrent) {
    return 'transparent';
  }
  if (isCompleted) {
    return theme.colors.primaryLightBlue;
  }
  return theme.colors.border;
};

const stepBorderColor = (theme: CardApplyThemeType, isCurrent: boolean, isCompleted: boolean) => {
  if (isCurrent) {
    return theme.colors.primaryLightBlue;
  }
  if (isCompleted) {
    return theme.colors.primaryLightBlue;
  }
  return theme.colors.border;
};

const SStep = styled.li<{ isCurrent: boolean; isCompleted: boolean }>(({ theme, isCurrent, isCompleted }) => {
  const speratorWidth = 110;
  const speratorMobileWidth = 80;

  return `
    margin:0;
    padding: ${theme.spacing.medium}px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 2px solid ${stepBorderColor(theme, isCurrent, isCompleted)};
    background-color: ${stepBackgroundColor(theme, isCurrent, isCompleted)};
    color: ${isCurrent ? theme.colors.primaryLightBlue : theme.colors.white};
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.medium};
    :not(:first-child) {
      margin-left: ${speratorMobileWidth + 12}px;
      @media only screen and ${theme.device.laptopS} {
        margin-left: ${speratorWidth + 12}px;
      }
      :after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        height: 3px;
        background-color: ${theme.colors.border};
        width: ${speratorMobileWidth}px;
        left:-${speratorMobileWidth + 8}px;
        @media only screen and ${theme.device.laptopS} {
          width: ${speratorWidth}px;
          left:-${speratorWidth + 8}px;
        }
      }
    }
  `;
});

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface IStepProps {
  progressDataAt: string;
  stepNumber: number;
  isCurrent: boolean;
  isCompleted: boolean;
}

// tslint:disable-next-line:variable-name
const Step: React.FC<IStepProps> = (props: IStepProps) => (
  <SStep data-at={`step_${props.stepNumber}_at_${props.progressDataAt}`} data-selected={props.isCurrent} isCurrent={props.isCurrent} isCompleted={props.isCompleted}>
    {props.isCompleted ? <i className="material-icons">done</i> : props.stepNumber}
  </SStep>
);

interface IProgressProps {
  dataAt: string;
  className?: string;
  numberOfSteps: number;
  currentStep?: number;
}

// tslint:disable-next-line:variable-name
const Progress: React.FC<IProgressProps> = (props) => {
  const steps = [];
  for (let i = 0, l = props.numberOfSteps; i < l; i++) {
    const stepNumber = i + 1;
    steps.push(<Step key={i + 1} progressDataAt={props.dataAt} stepNumber={i + 1} isCompleted={stepNumber < Number(props.currentStep)} isCurrent={stepNumber === props.currentStep} />);
  }
  return (
    <SProgress className={props.className} data-at={props.dataAt}>
      {steps}
    </SProgress>
  );
};

export default Progress;
